import { ChangeEvent, memo, useCallback, useState, VFC } from "react";
import {
  Box,
  Divider,
  Flex,
  FormLabel,
  HStack,
  FormControl,
  Heading,
  Input,
  Link,
  Stack,
  Select
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { PrimaryButton } from "../../atoms/button/PrimaryButton";
import { useRegister } from "../../../hooks/useRegister";
import { useMessage } from "../../../hooks/useMessage";

export const Register: VFC = memo(() => {
  const { register, loading } = useRegister();
  const { showMessage } = useMessage();
  const navigate = useNavigate();

  const [tenantId, setTenantId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [plan, setPlan] = useState("");

  const onClickRegister = () => {
    if (!(email || companyName)) {
      showMessage({
        title: "emailとcompanyNameが必要です。 これらの値を入力してください。",
        status: "error"
      });
    } else {
      register(
        tenantId,
        companyName,
        companyName,
        email,
        plan,
        email,
        email,
        firstName,
        lastName
      );
    }
  };

  const onClickCancel = useCallback(() => navigate("/login"), []);

  const onChangeTenantId = (e: ChangeEvent<HTMLInputElement>) =>
    setTenantId(e.target.value);

  const onChangeFirstName = (e: ChangeEvent<HTMLInputElement>) =>
    setFirstName(e.target.value);

  const onChangeLastName = (e: ChangeEvent<HTMLInputElement>) =>
    setLastName(e.target.value);

  const onChangeEmail = (e: ChangeEvent<HTMLInputElement>) =>
    setEmail(e.target.value);

  const onChangeCompanyName = (e: ChangeEvent<HTMLInputElement>) =>
    setCompanyName(e.target.value);

  const onChangePlan = (e: ChangeEvent<HTMLSelectElement>) =>
    setPlan(e.target.value);

  return (
    <Flex alignItems="center" justifyContent="center">
      <Box bg="white" w="sm" p={4} borderRadius="md" shadow="md">
        <Heading as="h1" size="md" textAlign="center">
          追加する市町村の情報
        </Heading>
        <Divider my={4} />
        <Stack spacing={6} py={4} px={10}>
          <FormControl>
            <FormLabel>市町村コード</FormLabel>
            <Input
              placeholder="tenant ID"
              value={tenantId}
              onChange={onChangeTenantId}
            />
          </FormControl>
          <FormControl>
            <FormLabel>氏名（姓）</FormLabel>
            <Input
              placeholder="lastName"
              value={lastName}
              onChange={onChangeLastName}
            />
          </FormControl>
          <FormControl>
            <FormLabel>氏名（名）</FormLabel>
            <Input
              placeholder="firstName"
              value={firstName}
              onChange={onChangeFirstName}
            />
          </FormControl>
          <FormControl>
            <FormLabel>メールアドレス</FormLabel>
            <Input placeholder="email" value={email} onChange={onChangeEmail} />
          </FormControl>
          <FormControl>
            <FormLabel>Company</FormLabel>
            <Input
              placeholder="companyName"
              value={companyName}
              onChange={onChangeCompanyName}
            />
          </FormControl>
          <FormControl>
            <FormLabel>Plan</FormLabel>
            <Select placeholder="plan" value={plan} onChange={onChangePlan}>
              <option value="Free Tier">Free Tier</option>
              <option value="Standard Tier">Standard Tier</option>
              <option value="Professional Tier">Professional Tier</option>
            </Select>
          </FormControl>
          <HStack>
            <PrimaryButton onClick={onClickRegister}>Register</PrimaryButton>
            <Link onClick={onClickCancel}>Cancel</Link>
          </HStack>
        </Stack>
      </Box>
    </Flex>
  );
});
